import PhotoSectionScreen from './PhotoSectionScreen';

import './InitialPhotosScreen.scss';

const InitialPhotosScreen = () => {
  return (
  <div className="initial-photos-screen">
    <div className="initial-photos-screen__intro">
      <h1>Fotos iniciales</h1>
      <p>Lo primero que necesitas hacer es tomar estas 4 fotografías.</p>
    </div>
    <PhotoSectionScreen idSection="OTHERS" link="initial" />
  </div>
  );
};

export default InitialPhotosScreen;